module.exports = __webpack_public_path__ + "static/media/arthur.605a2821.jpg";